import * as yup from 'yup';

export const PRODUCT_DESCRIPTION_MAX_LENGTH = 800;

export const productFormSchema = yup.object({
    categorySelections: yup
        .array()
        .of(
            yup.object({
                sectionId: yup.mixed<number | ''>().required(),
                categoryId: yup.mixed<number | ''>().required(),
            })
        )
        .required('Необходимо выбрать хотя бы одну категорию')
        .min(1, 'Необходимо выбрать хотя бы одну категорию')
        .test(
            'at-least-one-category',
            'Необходимо выбрать хотя бы одну категорию',
            (value) => {
                if (!value || value.length === 0) return false;
                return value.some((item) => item.categoryId !== '' && item.categoryId !== null && item.categoryId !== undefined);
            }
        ),
    name: yup.string().required('Название товара обязательно для заполнения'),
    description: yup
        .string()
        .max(
            PRODUCT_DESCRIPTION_MAX_LENGTH,
            `Описание не должно превышать ${PRODUCT_DESCRIPTION_MAX_LENGTH} символов`,
        ),
    price: yup.number().required('Цена товара обязательна для заполнения').min(0, 'Цена не может быть отрицательной'),
    composition: yup
        .array()
        .of(
            yup.object({
                value: yup.string().optional().default(''),
                count: yup.number().optional().min(0, 'Количество не может быть отрицательным').default(0),
            })
        )
        .required('Состав обязателен для заполнения')
        .test(
            'complete-items',
            'Укажите название и количество для каждой позиции состава',
            (value) => {
                if (!value || value.length === 0) return false;
                const isEmpty = (item: { value?: string; count?: number }) =>
                    !item?.value?.trim() && !(Number(item?.count) > 0);
                const isComplete = (item: { value?: string; count?: number }) =>
                    Boolean(item?.value?.trim()) && Number(item?.count) > 0;
                const filled = value.filter((item) => !isEmpty(item));
                if (filled.length === 0) return false;
                return filled.every(isComplete);
            }
        ),
    keywords: yup
        .array()
        .of(yup.string().required())
        .optional()
        .max(20, 'Можно указать не более 20 ключевых слов'),
    height: yup.number().required('Высота обязательна для заполнения').min(0, 'Высота не может быть отрицательной'),
    width: yup.number().required('Ширина обязательна для заполнения').min(0, 'Ширина не может быть отрицательной'),
    weight: yup
        .number()
        .required('Вес обязателен для заполнения')
        .min(0, 'Вес не может быть отрицательным')
        .max(15000, 'Вес не может быть больше 15 кг (15000 г)'),
    flowerCount: yup.number().nullable().optional(),
    isNotFlower: yup.boolean().optional(),
    flowerTypeIds: yup
        .array()
        .of(yup.number().required())
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать типы цветков').min(1, 'Необходимо выбрать хотя бы один тип цветка'),
            otherwise: (schema) => schema.optional(),
        }),
    assemblyTypeId: yup
        .number()
        .nullable()
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать тип сборки'),
            otherwise: (schema) => schema.optional(),
        }),
    assemblyTimeMinutes: yup
        .number()
        .nullable()
        .optional()
        .transform((value, originalValue) =>
            originalValue === '' || originalValue === null || originalValue === undefined
                ? null
                : value,
        )
        .min(0, 'Время сборки не может быть отрицательным'),
    colorIds: yup
        .array()
        .of(yup.number().required())
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать цвета').min(1, 'Необходимо выбрать хотя бы один цвет'),
            otherwise: (schema) => schema.optional(),
        }),
    images: yup
        .array()
        .of(yup.mixed<File | { id: number; url: string }>().required())
        .required('Необходимо загрузить изображения')
        .min(3, 'Необходимо загрузить минимум 3 изображения')
        .max(10, 'Максимальное количество изображений - 10'),
});
